import getLogger from '@ignitesales/logger-es';

const logger = getLogger();

const answerService = {
  getAnswer: async (request) => {
    logger.info('getAnswer', request);
    return new Promise((resolve) => { resolve({ status: 'success', value: [ '75013' ] }) })
  },
  saveAnswer: async (request) => {
    logger.info('saveAnswer', request);
    return new Promise((resolve) => { resolve({ status: 'success' }) })
  },
  removeAnswer: async (request) => {
    logger.info('removeAnswer', request);
    return new Promise((resolve) => { resolve({ status: 'success' }) })
  },
  actionStarted: async (request) => {
    logger.info('actionStarted', request);
    return new Promise((resolve) => { resolve({ status: 'success' }) })
  },
  actionCompleted: async (request) => {
    logger.info('actionCompleted', request);
    return new Promise((resolve) => { resolve({ status: 'success' }) })
  },
  removeProductAnswer: async (request) => {
    logger.info('removeProductAnswer', request);
    return new Promise((resolve) => { resolve({ status: 'success' }) })
  }
};

export default answerService;
